import {Component, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {ToastrService} from "ngx-toastr";
import {Cost} from "../../../models/cost";
import {CostType} from "../../../models/cost-type";
import {FormulaCost} from "../../../models/formula-cost";
import {CostView} from "../../../models/infix-formula/costView";
import { Registration } from "../../../models/registration";
import { Service } from "../../../models/service";
import {CostControllerService} from "../../../services/cost-controller/cost-controller.service";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";
import {ModalService} from "../../utils/base_modal.component";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "costs-table",
  templateUrl: "./costs-table.component.html",
  providers: [CostControllerService, ModalService, FormControllerService],
  styles: [".cursor-hand {cursor: pointer;}"],
})
export class CostsTableComponent extends TranslatedBaseError implements OnInit {

  @Input() public hideList: boolean = false;
  public serviceId: string;
  public determinantMapById: { [key: string]: string } = {};
  public baseUrl: string;
  public costs: Cost[] = [];
  public style: object = {};
  public cost: Cost;
  public showEdit: boolean = false;
  public showAdd: boolean = false;
  public costView: CostView = new CostView();
  public newCustomFilterBy: string;
  public elementsNumber: string;

  constructor(private route: ActivatedRoute,
              private serviceController: ServiceControllerService,
              private costControllerService: CostControllerService,
              private determinantService: DeterminantControllerService,
              private formControllerService: FormControllerService,
              private router: Router,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.costView.value = true;
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/coststable";
      this.getServiceDeterminantKeyName();
    });
    this.loadFormFieldGroup(this.getServiceCosts);
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public getServiceCosts() {
    this.serviceController.getService(this.serviceId).subscribe(
      (data: Service) => {
        if (data && data.registrations) {
          this.costs = [];
          data.registrations.forEach((reg: Registration) => {
            this.costControllerService.getRegistrationCostList(reg.id).subscribe(
              (data1) => {
                this.costs = this.costs.concat(data1);
                this.elementsNumber = " (" + this.costs.length + ")";
                this.costs.forEach((thisCost: Cost) => {
                  if (thisCost.costType === CostType.FORMULA) {
                    if ((thisCost as FormulaCost).formulaCostItems) {
                      (thisCost as FormulaCost).formulaCostItems.sort((a, b) => {
                        return a.sortOrder - b.sortOrder;
                      });
                    }
                    this.costView.reloadPrettyPrint(thisCost as FormulaCost, this.translateService);
                  }
                });
              },
            );
          });
        }
      });
  }

  public loadFormFieldGroup(cb) {
    this.formControllerService.getFilteredFormFields(this.serviceId, "number,datetime,datagrid,editgrid,catalog", false, false, false, false, false, false, false).subscribe(
        (fdata) => {
          fdata.forEach((item) => {
            item.title = item.fullName;
            item.id = item.fullKey || item.key;
            item.value = item.fullKey || item.key;
            this.costView.formFieldsGroup.push(item);
          });
          this.costView.formFieldsGroup.forEach((ffg) => {
            if (!this.costView.properties.find((prop) => prop.id === ffg.id)) {
              this.costView.properties.push({id: ffg.id, name: ffg.id, label: ffg.title, compareById: true});
            }
          });
          return cb.call(this);
        });
  }

  public deleteCost(cost: any) {
    this.costControllerService.deleteCost(cost.id).subscribe(
      (data) => {
        this.responseSuccessful("Cost deleted!");
        this.ngOnInit();
        this.router.navigate(["/services/" + this.serviceId + "/coststable"]);
      },
      (error) => this.showErrorMessage(error != null && error.error != null ? error.error.message : error),
    );
  }

  public onNewFilterBy(value) {
    this.newCustomFilterBy = value;
  }

  public loadCost(cost) {
    if (cost) {
      this.cost = this.costs.find((it) => {
        return it.id === cost.id;
      });
      this.showEdit = true;
    } else {
      this.cost = new Cost();
      this.cost.name =  this.newCustomFilterBy;
      this.showAdd = true;
    }
  }

  public updateCost(item) {
    return this.costControllerService.saveCost(item).subscribe(
      (data) => {
        item.isInRenameMode = false;
        item.isLoading = false;
        this.responseSuccessful("Cost saved!");
      },
      (error) => {
        this.ngOnInit();
        return this.showErrorMessage(error);
      },
    );
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSlider() {
    this.getServiceCosts();
    this.closeLayers();
  }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }

}
